<template>
    <div class="form-container">
        <div class="section-wrapper">
            <div class="mb-3">
                <MoneyField
                    :allowZero="true"
                    :customErrorMessage="errorMessage"
                    :label="label"
                    :name="name"
                    ref="name"
                    :validationRules="validationRules"
                />
            </div>

            <div class="row" v-if="minAnnualSalary && !isLendingtree">
                <div class="col">
                    <InfoBlock>
                        {{ additionalInfo }}
                    </InfoBlock>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { formatCurrency } from '@js/utilities/number.js'

import round from 'lodash/round'

function fields() {
    let fields

    const territory = process.env.IS_LENDINDTREE ? '' : process.env.TERRITORY

    switch (territory) {
        case 'aus':
            fields = {
                income: {
                    value: null,
                    mappedKey: 'income_net_monthly',
                    legacyMappedKey: 'income',
                    formatterOnQuery: 'numericFormatter',
                    formatterOnSummary: 'currencyFormat',
                    validationRules: {
                        required: true,
                    },
                },
            }
            break

        case 'usa':
            fields = {
                income: {
                    value: null,
                    mappedKey: 'annual_income',
                    legacyMappedKey: 'monthly_income',
                    formatterOnQuery: 'numericFormatter',
                    formatterOnSummary: 'currencyFormat',
                    validationRules: {
                        required: true,
                        minAnnualSalary: {
                            value: null,
                            min: 6000,
                        },
                    },
                    displayValue: true,
                    removeSummaryValidation: ['minAnnualSalary'],
                },
            }
            break

        default:
            fields = {
                income: {
                    value: null,
                    mappedKey: 'gross_annual_income',
                    formatterOnQuery: 'numericFormatter',
                    formatterOnSummary: 'currencyFormat',
                    validationRules: {
                        required: true,
                        minAnnualSalary: {
                            value: null,
                            min: 6000,
                        },
                    },
                    removeSummaryValidation: ['minAnnualSalary'],
                },
            }
            break
    }

    return fields
}

export default {
    // static settings to initialize step (not reactive inside this file!)
    stepDefinition() {
        return {
            name: 'financesIncome',
            route: {
                relativeUrl: `income`,
                name: 'apply.financesIncome',
                meta: {
                    title: 'form.sections.finances.income.heading',
                    additionalInfo: 'form.sections.finances.income.info',
                    tooltip: 'form.sections.finances.income.tooltip',
                    tooltipType: 'small',
                    customTooltip: process.env.IS_LENDINDTREE,
                    forceDisplayTooltip: true,
                },
            },
            fields: fields(),
        }
    },

    setup() {
        const store = useStore()
        const route = useRoute()

        return {
            store,
            route,
        }
    },
    mounted() {
        this.autoFocus(this.$refs.name)
    },
    data() {
        return {
            label: `${this.$t('form.fields.income.label')}`,
            name: 'income',
            errorMessage: `${this.$t('form.fields.income.errorMessage')}`,
            validationRules: this.store.getters.fieldValidationRules('income'),
        }
    },
    created() {
        this.emitter.emit('stepLoaded')
    },
    computed: {
        additionalInfo: function () {
            let annualIncome = this.store.getters.fieldValue('income')
            let monthlyIncome = annualIncome ? round(annualIncome / 12, 2) : 0

            return this.route?.meta?.additionalInfo
                ? this.$t(this.route.meta.additionalInfo, { figure: formatCurrency(monthlyIncome) })
                : null
        },
        minAnnualSalary: function () {
            return this.store.getters.field('income')?.validationRules?.minAnnualSalary
        },
        isLendingtree: function () {
            return process.env.IS_LENDINDTREE
        },
    },
}
</script>

<style lang="scss" scoped>
.section-wrapper {
    margin-left: auto;
    margin-right: auto;
}
</style>
